/**
 * @file 网站配置
 */
// import { requiredNumber } from 'element-plus/es/components/table-v2/src/common';
import { isClient } from '@vueuse/shared';
import siteConfig from './site';
import { getEnvironmentHost } from './host';

// 网站支持的语言ISO列表
export const langs: string[] = siteConfig.supportLanguages.map(item => item.iso);

// 网站默认语言(准备删除)
export const lang = 'en-US';

// 语言缓存key
export const STORE_LANG = 'lang';

export const STORE_LEGAL_KEY = 'legal_flag';

export const defaultLang = isClient ? (localStorage.getItem(STORE_LANG) || 'en-US') : 'en-US';

export const defaultLegalFlag = () => isClient ? (localStorage.getItem(STORE_LEGAL_KEY) || 'USD') : 'USD';

// 获取默认语言
export const getDefaultLang = () => {
  const localStoreLang: string = localStorage.getItem(STORE_LANG) || lang;
  const langInfo = siteConfig.supportLanguagesMap[localStoreLang];

  return {
    langKey: localStoreLang,
    ...langInfo
  };
};

// 退出登录不跳登录页的页面(可以改成在路由meta里配置)
export const stayRoute = [
  '/', '/spot', '/h5/vip', '/vip',
  /^\/spot\/[a-zA-Z0-9]{1,20}_[a-zA-Z0-9]{1,20}$/,
  '/markets', '/futures', /^\/futures\/[a-zA-Z0-9\-]{1,20}$/,
  '/lite-perpetual', /^\/lite-perpetual\/[a-zA-Z0-9\-]{1,20}$/,
  '/about-us', '/futures-activity', '/copytrading',
  '/download', '/card-deposit', '/activity/reward-center',
  '/affiliates/exclusive-activities',
  '/h5//affiliates/exclusive-activities', '/halloween', '/activity/christmas',
  '/activity/dragon', '/futures-strategy', /^\/futures-strategy\/[a-zA-Z0-9\-]{1,20}$/,
  '/trading-bot'
];

// 谨慎！！不要修改，避免把测试环境地址带去线上
const env = import.meta.env.MODE;

export const apiHost = {
  api: getEnvironmentHost(env).api,
  plazaApi: getEnvironmentHost(env).plazaApi,
  ws: getEnvironmentHost(env).ws,
  wsIm: getEnvironmentHost(env).wsIm
};

// 当前环境的location属性
export const envHost: any = isClient ? window.location.host : getEnvironmentHost(env).web;
export const h5Host: string = getEnvironmentHost(env).h5;
export const envHref: string = isClient ? window.location.href : `https://${envHost}/`;
export const envOrigin: string = isClient ? window.location.origin : `https://${envHost}`;

// 稳定币定义
export const stableToken = ['USDC', 'DAI'];

// API Document 链接
export const getApiUrl = () => {
  const localeLang = defaultLang;
  const apiLangMap: Record<string, string> = {
    'zh-CN': 'cn',
    'en-US': 'en'
  };
  const lang = localeLang && apiLangMap[localeLang] ? apiLangMap[localeLang] : 'en';

  return `https://toobit-docs.github.io/apidocs/spot/v1/${lang}/#45fa4e00db`;
};

